import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import { TypographyH3, TypographyP } from '@/Components/shadcn';

const PageFailedLoading = (): React.JSX.Element => {
    return (
        <div className="flex h-full items-center justify-center">
            <div className="flex flex-col items-center">
                <TypographyH3>{UIStrings.OopsSomethingWentWrong}</TypographyH3>
                <TypographyP>{UIStrings.PleaseRefresh}</TypographyP>
            </div>
        </div>
    );
};

export default PageFailedLoading;
